/**
 * Created by jhcao on 2020/05/11.
 * 指尖文字识别示例JSON数据
 */
var bgImageList = [
  {
    url: 'https://cdn.aidaxue.com/finger-word-discern/case/example-01.jpg',
    result: {
      'mode': 'finger+ocr',
      'version_engine': 'V1.0.9',
      'version_json': '1.0',
      'width': 0,
      'finger_pos': {
        'pos_y': 514.2857055664062,
        'pos_x': 371.4285583496094,
        'dir_x': -7.142857074737549,
        'dir_y': -96.42857360839844,
        'thickness': 95.29759979248047,
        'angle': -96.33390045166016
      },
      'finger_ocr': {
        'char': {
          'id': 4,
          'list': [{
            'score': 36.43702697753906,
            'coord': [{
              'x': 330,
              'y': 489
            }, {
              'x': 345,
              'y': 490
            }, {
              'x': 345,
              'y': 513
            }, {
              'x': 330,
              'y': 512
            }],
            'content': 'b'
          }, {
            'score': 26.6902904510498,
            'coord': [{
              'x': 346,
              'y': 490
            }, {
              'x': 350,
              'y': 490
            }, {
              'x': 350,
              'y': 513
            }, {
              'x': 346,
              'y': 513
            }],
            'content': 'i'
          }, {
            'score': 20.81758308410645,
            'coord': [{
              'x': 351,
              'y': 490
            }, {
              'x': 359,
              'y': 490
            }, {
              'x': 359,
              'y': 513
            }, {
              'x': 351,
              'y': 513
            }],
            'content': 'r'
          }, {
            'score': 14.78708076477051,
            'coord': [{
              'x': 360,
              'y': 490
            }, {
              'x': 368,
              'y': 490
            }, {
              'x': 368,
              'y': 513
            }, {
              'x': 360,
              'y': 513
            }],
            'content': 't'
          }, {
            'score': 13.41830444335938,
            'coord': [{
              'x': 369,
              'y': 490
            }, {
              'x': 382,
              'y': 490
            }, {
              'x': 382,
              'y': 513
            }, {
              'x': 369,
              'y': 513
            }],
            'content': 'h'
          }, {
            'score': 23.37767219543457,
            'coord': [{
              'x': 383,
              'y': 490
            }, {
              'x': 399,
              'y': 490
            }, {
              'x': 399,
              'y': 513
            }, {
              'x': 383,
              'y': 513
            }],
            'content': 'd'
          }, {
            'score': 37.79949188232422,
            'coord': [{
              'x': 400,
              'y': 490
            }, {
              'x': 414,
              'y': 490
            }, {
              'x': 414,
              'y': 513
            }, {
              'x': 400,
              'y': 513
            }],
            'content': 'a'
          }, {
            'score': 48.77699279785156,
            'coord': [{
              'x': 415,
              'y': 490
            }, {
              'x': 422,
              'y': 490
            }, {
              'x': 422,
              'y': 513
            }, {
              'x': 415,
              'y': 513
            }],
            'content': 'y'
          }, {
            'score': 999999,
            'coord': [{
              'x': 423,
              'y': 490
            }, {
              'x': 430,
              'y': 490
            }, {
              'x': 430,
              'y': 513
            }, {
              'x': 423,
              'y': 513
            }],
            'content': '.'
          }]
        },
        'sent': {
          'coord': [{
            'x': 330,
            'y': 490
          }, {
            'x': 432,
            'y': 491
          }, {
            'x': 432,
            'y': 513
          }, {
            'x': 330,
            'y': 512
          }],
          'content': 'It was Mocky\'s birthday'
        },
        'word': {
          'id': 0,
          'list': [{
            'score': 42.60700988769531,
            'coord': [{
              'x': 330,
              'y': 489
            }, {
              'x': 422,
              'y': 490
            }, {
              'x': 422,
              'y': 513
            }, {
              'x': 330,
              'y': 512
            }],
            'content': 'birthday'
          }, {
            'score': 999999,
            'coord': [{
              'x': 423,
              'y': 490
            }, {
              'x': 430,
              'y': 490
            }, {
              'x': 430,
              'y': 513
            }, {
              'x': 423,
              'y': 513
            }],
            'content': '.'
          }]
        }
      },
      'height': 0
    }
  },
  {
    url: 'https://cdn.aidaxue.com/finger-word-discern/case/example-02.jpg',
    result: {
      'mode': 'finger+ocr',
      'version_engine': 'V1.0.10',
      'version_json': '1.0',
      'width': 0,
      'finger_pos': {
        'pos_y': 220,
        'pos_x': 132,
        'dir_x': 0,
        'dir_y': -36,
        'thickness': 64,
        'angle': -89.99363708496094
      },
      'finger_ocr': {
        'char': {
          'id': 2,
          'list': [{
            'score': 60.6671257019043,
            'coord': [{
              'x': 61,
              'y': 181
            }, {
              'x': 94,
              'y': 185
            }, {
              'x': 92,
              'y': 210
            }, {
              'x': 59,
              'y': 206
            }],
            'content': '刮'
          }, {
            'score': 32.43165969848633,
            'coord': [{
              'x': 95,
              'y': 185
            }, {
              'x': 122,
              'y': 188
            }, {
              'x': 120,
              'y': 212
            }, {
              'x': 93,
              'y': 210
            }],
            'content': '的'
          }, {
            'score': 18.61618995666504,
            'coord': [{
              'x': 123,
              'y': 188
            }, {
              'x': 153,
              'y': 191
            }, {
              'x': 150,
              'y': 216
            }, {
              'x': 121,
              'y': 213
            }],
            'content': '风'
          }, {
            'score': 36.00694274902344,
            'coord': [{
              'x': 154,
              'y': 191
            }, {
              'x': 178,
              'y': 193
            }, {
              'x': 175,
              'y': 218
            }, {
              'x': 151,
              'y': 216
            }],
            'content': '是'
          }, {
            'score': 60.46951675415039,
            'coord': [{
              'x': 179,
              'y': 194
            }, {
              'x': 206,
              'y': 196
            }, {
              'x': 203,
              'y': 219
            }, {
              'x': 176,
              'y': 218
            }],
            'content': '绿'
          }, {
            'score': 84.32266998291016,
            'coord': [{
              'x': 207,
              'y': 196
            }, {
              'x': 227,
              'y': 199
            }, {
              'x': 224,
              'y': 219
            }, {
              'x': 204,
              'y': 219
            }],
            'content': '的'
          }]
        },
        'sent': {
          'coord': [{
            'x': 62,
            'y': 182
          }, {
            'x': 227,
            'y': 199
          }, {
            'x': 226,
            'y': 219
          }, {
            'x': 59,
            'y': 206
          }],
          'content': '刮的风是绿的'
        },
        'word': {
          'id': 2,
          'list': [{
            'score': 60.6671257019043,
            'coord': [{
              'x': 61,
              'y': 181
            }, {
              'x': 94,
              'y': 185
            }, {
              'x': 92,
              'y': 210
            }, {
              'x': 59,
              'y': 206
            }],
            'content': '刮'
          }, {
            'score': 32.43165969848633,
            'coord': [{
              'x': 95,
              'y': 185
            }, {
              'x': 122,
              'y': 188
            }, {
              'x': 120,
              'y': 212
            }, {
              'x': 93,
              'y': 210
            }],
            'content': '的'
          }, {
            'score': 18.61618995666504,
            'coord': [{
              'x': 123,
              'y': 188
            }, {
              'x': 153,
              'y': 191
            }, {
              'x': 150,
              'y': 216
            }, {
              'x': 121,
              'y': 213
            }],
            'content': '风'
          }, {
            'score': 36.00694274902344,
            'coord': [{
              'x': 154,
              'y': 191
            }, {
              'x': 178,
              'y': 193
            }, {
              'x': 175,
              'y': 218
            }, {
              'x': 151,
              'y': 216
            }],
            'content': '是'
          }, {
            'score': 60.46951675415039,
            'coord': [{
              'x': 179,
              'y': 194
            }, {
              'x': 206,
              'y': 196
            }, {
              'x': 203,
              'y': 219
            }, {
              'x': 176,
              'y': 218
            }],
            'content': '绿'
          }, {
            'score': 84.32266998291016,
            'coord': [{
              'x': 207,
              'y': 196
            }, {
              'x': 227,
              'y': 199
            }, {
              'x': 224,
              'y': 219
            }, {
              'x': 204,
              'y': 219
            }],
            'content': '的'
          }]
        }
      },
      'height': 0,
      'sid': 'ocr0008762c@dx172124a92c9a11d902'
    }
  },
  {
    url: 'https://cdn.aidaxue.com/finger-word-discern/case/example-03.jpg',
    result: {
      'mode': 'finger+ocr',
      'version_engine': 'V1.0.9',
      'version_json': '1.0',
      'width': 0,
      'finger_pos': {
        'pos_y': 578.5714111328125,
        'pos_x': 371.4285583496094,
        'dir_x': -7.142857074737549,
        'dir_y': -96.42857360839844,
        'thickness': 88.35226440429688,
        'angle': -96.33390045166016
      },
      'finger_ocr': {
        'char': {
          'id': 3,
          'list': [{
            'score': 56.56008911132812,
            'coord': [{
              'x': 313,
              'y': 532
            }, {
              'x': 337,
              'y': 533
            }, {
              'x': 336,
              'y': 562
            }, {
              'x': 312,
              'y': 561
            }],
            'content': 'A'
          }, {
            'score': 40.1502685546875,
            'coord': [{
              'x': 338,
              'y': 533
            }, {
              'x': 355,
              'y': 533
            }, {
              'x': 354,
              'y': 562
            }, {
              'x': 337,
              'y': 562
            }],
            'content': 's'
          }, {
            'score': 31.46100234985352,
            'coord': [{
              'x': 356,
              'y': 533
            }, {
              'x': 373,
              'y': 534
            }, {
              'x': 372,
              'y': 563
            }, {
              'x': 355,
              'y': 562
            }],
            'content': 'h'
          }, {
            'score': 30.89166641235352,
            'coord': [{
              'x': 374,
              'y': 534
            }, {
              'x': 384,
              'y': 534
            }, {
              'x': 383,
              'y': 563
            }, {
              'x': 373,
              'y': 563
            }],
            'content': 'i'
          }, {
            'score': 34.86966705322266,
            'coord': [{
              'x': 385,
              'y': 534
            }, {
              'x': 395,
              'y': 535
            }, {
              'x': 394,
              'y': 563
            }, {
              'x': 384,
              'y': 563
            }],
            'content': 'g'
          }, {
            'score': 46.32813262939453,
            'coord': [{
              'x': 396,
              'y': 535
            }, {
              'x': 420,
              'y': 535
            }, {
              'x': 419,
              'y': 564
            }, {
              'x': 395,
              'y': 564
            }],
            'content': 'h'
          }, {
            'score': 64.27127075195312,
            'coord': [{
              'x': 421,
              'y': 535
            }, {
              'x': 438,
              'y': 536
            }, {
              'x': 437,
              'y': 565
            }, {
              'x': 420,
              'y': 564
            }],
            'content': 'a'
          }, {
            'score': 82.17442321777344,
            'coord': [{
              'x': 439,
              'y': 536
            }, {
              'x': 459,
              'y': 537
            }, {
              'x': 459,
              'y': 565
            }, {
              'x': 438,
              'y': 565
            }],
            'content': 's'
          }, {
            'score': 100.8430709838867,
            'coord': [{
              'x': 460,
              'y': 537
            }, {
              'x': 477,
              'y': 537
            }, {
              'x': 477,
              'y': 566
            }, {
              'x': 460,
              'y': 565
            }],
            'content': 'y'
          }, {
            'score': 116.2090301513672,
            'coord': [{
              'x': 478,
              'y': 537
            }, {
              'x': 492,
              'y': 538
            }, {
              'x': 491,
              'y': 566
            }, {
              'x': 477,
              'y': 566
            }],
            'content': 'o'
          }, {
            'score': 127.2704315185547,
            'coord': [{
              'x': 493,
              'y': 538
            }, {
              'x': 500,
              'y': 538
            }, {
              'x': 499,
              'y': 567
            }, {
              'x': 492,
              'y': 567
            }],
            'content': 'u'
          }]
        },
        'sent': {
          'coord': [{
            'x': 314,
            'y': 533
          }, {
            'x': 502,
            'y': 538
          }, {
            'x': 502,
            'y': 566
          }, {
            'x': 313,
            'y': 561
          }],
          'content': 'Jump, jump, As high as you'
        },
        'word': {
          'id': 1,
          'list': [{
            'score': 48.35517883300781,
            'coord': [{
              'x': 313,
              'y': 532
            }, {
              'x': 355,
              'y': 533
            }, {
              'x': 354,
              'y': 562
            }, {
              'x': 312,
              'y': 561
            }],
            'content': 'As'
          }, {
            'score': 38.89456939697266,
            'coord': [{
              'x': 356,
              'y': 533
            }, {
              'x': 420,
              'y': 535
            }, {
              'x': 419,
              'y': 564
            }, {
              'x': 355,
              'y': 562
            }],
            'content': 'high'
          }, {
            'score': 73.22284698486328,
            'coord': [{
              'x': 421,
              'y': 535
            }, {
              'x': 459,
              'y': 537
            }, {
              'x': 459,
              'y': 565
            }, {
              'x': 420,
              'y': 564
            }],
            'content': 'as'
          }, {
            'score': 114.0567474365234,
            'coord': [{
              'x': 460,
              'y': 537
            }, {
              'x': 500,
              'y': 538
            }, {
              'x': 499,
              'y': 567
            }, {
              'x': 460,
              'y': 565
            }],
            'content': 'you'
          }]
        }
      },
      'height': 0
    }
  }
]

function fingerData () {
  return bgImageList
}

export { fingerData }



// WEBPACK FOOTER //
// ./src/js/libs/json/finger-word-discern.js